{
  "en": {
    "errors": {
      "audioNotSupported": "Audio format not supported",
      "audioRecordingDeviceError": "Audio recording device error",
      "connectionAuthenticationFailed": "Connection was rejected by server. Authentication failed.",
      "connectionRejected": "Connection was rejected by the server",
      "createFromTemplateFailed": "Failed to create from template",
      "createItemFailed": "Failed to create item",
      "deleted": {
        "header": "This content was deleted",
        "link": "To the fobizz Tools",
        "paragraph": "The person who shared this content has just deleted it. Therefore it can no longer be displayed."
      },
      "downloadFailed": "The file could not be downloaded. Please refresh the page and try again.",
      "error": "Error",
      "fileAlreadyExists": "File '{filename}' already exists",
      "fileUploadFailed": "Failed to upload file",
      "forbidden": {
        "header": "Unfortunately, you do not have access to this content",
        "link": "To the fobizz tools",
        "paragraph": "You need an invitation via access link to see this content. Reach out to the person who sent you the link and ask them to send you the correct link."
      },
      "generic": {
        "header": "Sorry, something went wrong!",
        "link": "To the fobizz tools",
        "paragraph": "An error occurred while processing your request. Please try again later!"
      },
      "h5pContentNotFound": "H5P content not found",
      "h5pUploadFailed": "H5P file upload failed",
      "liveConnectionLost": {
        "description": "This page is no longer updating automatically. Reload it to get live updates again.",
        "reload": "Reload page",
        "title": "No live connection"
      },
      "toTeachImportFailed": "Failed to import the to teach exercise",
      "toTeachNoH5pDownload": "This exercise does not have an H5P download",
      "imageUploadFailed": "Image upload failed",
      "internalError": "Internal Error",
      "invalidUrl": "This is not a valid URL.",
      "jobProcessingFailed": "Failed to process",
      "jobProcessingFailedWithDetails": "Failed to process: {message}",
      "jobTimeout": "Processing is taking unusually long and was aborted. Please try again.",
      "noAudioInputDeviceFound": "No audio input device found",
      "noVideoInputDeviceFound": "No video input device found",
      "notFound": {
        "header": "Unfortunately, that did not work out!",
        "link": "To the fobizz tools",
        "paragraph": "The address you are looking for does not exist – or no longer exists!"
      },
      "partnerNotEnabled": "Unfortunately our partners have been deactivated for you.",
      "previewImageGenerationFailed": "The image generation failed. Please try again.",
      "previewImageGenerationTimeout": "The image generation is taking unusually long and has been canceled. Please try again.",
      "remixFailed": "Failed to remix content",
      "somethingWentWrong": "Something went wrong",
      "unauthorized": {
        "header": "Unfortunately, that did not work out!",
        "link": "To the fobizz tools",
        "paragraph": "Please log in to access this page!"
      },
      "unknownAudioRecordingError": "Unknown audio recording error",
      "unknownErrorRefresh": "Unknown error occurred. Refreshing page!",
      "unknownVideoRecordingError": "Unknown video recording error",
      "uploadFileTooLarge": "File cannot be uploaded because it is larger than {maxSize} MB",
      "uploadTotalSizeExceeded": "File cannot be uploaded because it would exceed the total size limit of {maxTotalSize} MB",
      "uploadFileTooSmall": "File cannot be uploaded because it is 0 MB",
      "validationError": "Validation Error",
      "videoRecordingDeviceError": "Video recording device error"
    }
  }
}
